<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col lg:w-12/12 w-full">
        <vx-card title="Destination">
          <template>
            <div>
              <div v-if="!showMap" class="flex flex-col items-center justify-center" style="height: 200px">
                <p class="mb-4 text-center">Click to display the map</p>
                <vs-button icon-pack="feather" icon="icon-map" @click="showMap = true">Afficher la carte</vs-button>
              </div>
              <GmapMap v-else id="map" :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 500px">
                <GmapInfoWindow v-for="(m, index) in markers" :key="index" :position="m" :closable="false">
                  <vs-chip :color="isFullyPrepared(index) ? 'success' : 'danger'" class="ag-grid-cell-chips">
                    <span>
                      <small>{{ index + 1 }}.</small>
                      <b> #{{ m.quotationref }} ⟶ </b>
                      <span v-if="isFullyPrepared(index)">
                        ready&nbsp;({{ Math.abs(m.volume.toFixed(0)) }} m³)
                      </span>
                      <span v-else>
                        <big>{{ Math.abs(getPreparationPercentage(index).toFixed(0)) }}%</big> ready
                      </span>&nbsp;({{ Math.abs(m.volume.toFixed(0)) }} m³)
                    </span>
                  </vs-chip>
                  <br />
                  <vs-chip :color="m.transport && m.transport.people.length > 0 ? '#A9CAB7' : '#c2d1f0'"
                    class="ag-grid-cell-chips" v-if="m.transport">
                    <span>{{ m.transport.id }}</span>&nbsp;
                    <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                  </vs-chip>
                </GmapInfoWindow>
              </GmapMap>
            </div>
          </template>
        </vx-card>
        <iframe
      src="/web/dashboard/map"
      width="600"
      height="400"
      frameborder="0"
      allowfullscreen
    ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
const themeColors = ["#28C76F", "#EA5455", "#EA5455", "#FF9F43", "#1E1E1E"];
import moduleDataListDashboard from "@/store/dashboard/moduleOperationList.js";

export default {
  data() {
    return {
      updatedDate: null,
      createdDate: null,
      OpenedPopupTitle: null,
      popupDescription: false,
      dataModelDescription: "1. The quotation was edited within the past <b>4 days.</b> <br/>2; The time difference between the quotation's creation date and its most recent edit <b>is greater than 24 hours.</b><br/><br/>",
      popup_mail_top: null,
      popup_quotation_dashboard_product: null,
      popupActive: false,
      itemsPerPage: 25,
      toberefreshed: false,
      selected: [],
      seconds: 59,
      isMounted: false,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      // Charge la carte Google uniquement sur clic (évite un Map Load facturable par visite).
      showMap: false,
      boundRating: 0,

      purchaseOrdersList: [],
      quotationList: [],
      quotationProductList: [],
      saleList: [],
      evolutionStock: {},
      valuePiquet: [],
      valueBrut: [],
      isGraphFailed: true,
      activePrompt2: false,
      quotationRefClickedPrompt2: null,
      vartotalVolumeReady: 0,
      currentlyworking: [],

      greenIcon: "http://maps.google.com/mapfiles/kml/paddle/grn-blank.png",
      whiteIcon: "http://maps.google.com/mapfiles/kml/paddle/wht-blank.png",
      blueIcon: "http://maps.google.com/mapfiles/kml/paddle/blu-blank.png",
    };
  },
  computed: {
    quotation_dashboard() {
      return this.$store.state.dataListDashboard.quotation_dashboard;
    },
  },
  methods: {
    isFullyPrepared(index) {
      const marker = this.markers[index];
      return Math.abs(((marker.volume - marker.volumetoprepare) / marker.volume) * 100) === 100;
    },
    getPreparationPercentage(index) {
      const marker = this.markers[index];
      return Math.abs(((marker.volume - marker.volumetoprepare) / marker.volume) * 100);
    },
  },
  created() {
    if (!moduleDataListDashboard.isRegistered) {
        this.$store.registerModule(
          "dataListDashboard",
          moduleDataListDashboard
        );
        moduleDataListDashboard.isRegistered = true;
      }
    this.$store
      .dispatch("dataListDashboard/fetchQuotation")
      .then((response) => {
        this.markers = this.quotation_dashboard;
      })
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
.gm-style-iw {
  padding: 10px !important;
  /* Uniformise le padding interne */
  padding-top: 0px !important;
  /* Supprime le padding en haut */
  margin-top: 0px;
  /* Supprime la marge en haut */
  opacity: 0.95;
  /* Légère transparence pour lisibilité */
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.2);
}

.gm-style-iw>div {
  padding-top: -18px !important;
  /* Supprime tout padding ajouté dans le div interne */
  margin-top: -18px !important;
  /* Supprime toute marge interne */
}

button.gm-ui-hover-effect {
  visibility: hidden;
}

#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
.ag-grid-cell-chips {
  top: 12px;
  transform: translateY(-50%);
  line-height: 1;
}
</style>
